import React from 'react';
import { Card, Row, Col, Form, Input, Button, Table, Tag, Select,
	DatePicker, Empty, Typography, Tooltip, Modal, Alert, Checkbox, message,
} from 'antd';
import {
	RedoOutlined, SearchOutlined, WarningOutlined,
	CheckCircleOutlined, UndoOutlined, ExclamationCircleOutlined,
} from '@ant-design/icons';
import { connect } from 'react-redux';
import { initHandler, ajaxViewHandler, ajaxHandler, setConfig } from '../../store/actions';
import { Helmet } from 'react-helmet';
import Config from '../../Config';
import ErrorAlertModal from '../../components/ErrorAlertModal';

const { Text } = Typography;
const { Option } = Select;
const { RangePicker } = DatePicker;
const { TextArea } = Input;

const configClass = {
	title: 'Audit Notice Rusak',
	apiUrl: {
		audit: 'transaksi/api/permintaan-batal-notice/audit-rusak/',
		cabut: 'transaksi/api/permintaan-batal-notice/',
		upt: 'pegawai/api/upt/',
		kabupaten: 'master/api/kabupaten/',
	},
};

const config = new Config();

// Halaman ini SENGAJA tidak menghapus catatan rusak (hard-delete) - cuma
// "mencabut" (soft-revoke, lihat PermintaanBatalNoticeViewset.cabut) supaya
// jejak audit "pernah dilaporkan rusak, oleh siapa, kapan" tetap utuh. Lihat
// diskusi 2026-10-02 - akar masalah: petugas kadang salah lapor nomor rusak
// padahal fisiknya baik2 saja / nomor itu sudah dipegang transaksi aktif sah,
// bikin Koreksi Nomor Notice tidak bisa membetulkan transaksi itu.
class AuditNoticeRusak extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			isMobile: window.innerWidth <= 768,
			loading: false,
			listData: [],
			pagination: { current: 1, pageSize: 25, total: 0 },
			ringkasan: { total_belum_dicabut: 0, total_bentrok: 0, total_sudah_dicabut: 0 },

			filterKodeNotice: '',
			filterNomorNotice: '',
			filterNomorPolisi: '',
			filterUptId: undefined,
			filterKabupatenId: undefined,
			filterStatusCabut: 'belum',
			filterBentrokSaja: false,
			filterTanggal: [],

			loadingUpt: false, listUpt: [],
			loadingKabupaten: false, listKabupaten: [],

			modalCabut: false, cabutTarget: null, alasan: '', loadingCabut: false,

			errTitle: '', errMsg: '',
		};
	}

	componentDidMount() {
		this.props.initHandler();
		this._handleResize = () => this.setState({ isMobile: window.innerWidth <= 768 });
		window.addEventListener('resize', this._handleResize);
		this.fetchData();
		this.fetchKabupatenList();
		this.initKabupatenFromCookie();
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this._handleResize);
	}

	_getKabupatenId() {
		try {
			const raw = this.props.uptDipilih;
			if (!raw) return null;
			const obj = typeof raw === 'string' ? JSON.parse(raw) : raw;
			return obj.kabupaten || null;
		} catch {
			return null;
		}
	}

	isKabupatenLocked() {
		return !this.props.is_superuser && Boolean(this._getKabupatenId());
	}

	initKabupatenFromCookie() {
		const kabupatenId = this._getKabupatenId();
		if (kabupatenId) this.setState({ filterKabupatenId: kabupatenId });
		this.fetchUptList('', kabupatenId);
	}

	fetchKabupatenList = (search = '') => {
		this.setState({ loadingKabupaten: true });
		this.props.ajaxViewHandler('get', `${configClass.apiUrl.kabupaten}?limit=200${search ? '&search=' + encodeURIComponent(search) : ''}`)
			.then(() => {
				if (this.props.isSuccess) {
					const data = this.props.responseMsg;
					this.setState({ listKabupaten: Array.isArray(data) ? data : (data.results || []) });
				}
				this.setState({ loadingKabupaten: false });
			}).catch(() => this.setState({ loadingKabupaten: false }));
	};

	fetchUptList = (search = '', kabupatenId = this.state.filterKabupatenId) => {
		this.setState({ loadingUpt: true });
		let url = `${configClass.apiUrl.upt}?limit=200`;
		if (kabupatenId) url += `&kabupaten=${kabupatenId}`;
		if (search) url += `&search=${encodeURIComponent(search)}`;
		this.props.ajaxViewHandler('get', url)
			.then(() => {
				if (this.props.isSuccess) {
					const data = this.props.responseMsg;
					this.setState({ listUpt: Array.isArray(data) ? data : (data.results || []) });
				}
				this.setState({ loadingUpt: false });
			}).catch(() => this.setState({ loadingUpt: false }));
	};

	fetchData = (page = 1) => {
		const {
			pagination, filterKodeNotice, filterNomorNotice, filterNomorPolisi,
			filterUptId, filterKabupatenId, filterStatusCabut, filterBentrokSaja, filterTanggal,
		} = this.state;
		const limit = pagination.pageSize, offset = (page - 1) * limit;
		let params = `?limit=${limit}&offset=${offset}&status_cabut=${filterStatusCabut}`;
		if (filterKodeNotice) params += `&kode_notice=${encodeURIComponent(filterKodeNotice)}`;
		if (filterNomorNotice) params += `&nomor_notice=${encodeURIComponent(filterNomorNotice)}`;
		if (filterNomorPolisi) params += `&nomor_polisi=${encodeURIComponent(filterNomorPolisi)}`;
		// Backend (PermintaanBatalNoticeViewset._audit_scope_qs) tetap men-scope
		// hasil sesuai level akses pegawai - filter kabupaten/UPT di sini cuma
		// berlaku efektif utk level yang memang diizinkan lintas-UPT (superadmin).
		if (filterUptId) params += `&upt_id=${filterUptId}`;
		if (filterKabupatenId) params += `&kabupaten_id=${filterKabupatenId}`;
		if (filterBentrokSaja) params += `&bentrok_saja=1`;
		if (filterTanggal && filterTanggal[0]) params += `&tanggal_dari=${filterTanggal[0].format('YYYY-MM-DD')}`;
		if (filterTanggal && filterTanggal[1]) params += `&tanggal_sampai=${filterTanggal[1].format('YYYY-MM-DD')}`;

		this.setState({ loading: true });
		this.props.ajaxViewHandler('get', configClass.apiUrl.audit + params)
			.then(() => {
				if (this.props.isSuccess) {
					const data = this.props.responseMsg || {};
					this.setState({
						listData: data.results || [],
						pagination: { ...pagination, current: page, total: data.count || 0 },
						ringkasan: data.ringkasan || { total_belum_dicabut: 0, total_bentrok: 0, total_sudah_dicabut: 0 },
					});
				}
				this.setState({ loading: false });
			}).catch(() => this.setState({ loading: false }));
	};

	handleFilter = () => this.fetchData(1);

	handleReset = () => {
		this.setState({
			filterKodeNotice: '', filterNomorNotice: '', filterNomorPolisi: '',
			filterUptId: undefined, filterKabupatenId: undefined,
			filterStatusCabut: 'belum', filterBentrokSaja: false, filterTanggal: [],
		}, () => {
			this.initKabupatenFromCookie();
			this.fetchData(1);
		});
	};

	openCabut = (row) => {
		this.setState({ modalCabut: true, cabutTarget: row, alasan: '' });
	};

	_showError = (title, fallback) => {
		const msg = this.props.responseMsg;
		const errMsg = (typeof msg === 'string' ? msg : (msg && msg.error)) || fallback;
		this.setState({ errTitle: title, errMsg });
	};

	handleCabut = () => {
		const { cabutTarget, alasan } = this.state;
		if (!cabutTarget) return;
		if (alasan.trim().length < 10) {
			message.warning({ content: 'Alasan pencabutan wajib diisi minimal 10 karakter.', duration: 2, key: 'toast' });
			return;
		}
		this.setState({ loadingCabut: true });
		this.props.ajaxHandler('post', `${configClass.apiUrl.cabut}${cabutTarget.id}/cabut/`, {
			alasan: alasan.trim(),
		}, false, true).then(() => {
			if (this.props.isSuccess) {
				message.success({ content: 'Catatan notice rusak berhasil dicabut.', duration: 2, key: 'toast' });
				this.setState({ modalCabut: false, cabutTarget: null, alasan: '' });
				this.fetchData(this.state.pagination.current);
			} else {
				this._showError('Gagal Mencabut Catatan', 'Gagal mencabut catatan notice rusak.');
			}
			this.setState({ loadingCabut: false });
		}).catch(() => {
			this._showError('Gagal Mengirim', 'Gagal mengirim, coba lagi.');
			this.setState({ loadingCabut: false });
		});
	};

	_columns() {
		return [
			{ title: 'Tanggal Dicatat', dataIndex: 'created_at', key: 'created_at', width: 150 },
			{ title: 'Kode+Nomor', key: 'nomor', width: 150,
				render: (_, row) => (
					<Text style={{ fontFamily: 'monospace', fontWeight: 700 }}>
						{row.kode_notice || ''} {String(row.nomor_notice).padStart(7, '0')}
					</Text>
				) },
			{ title: 'Nomor Polisi', dataIndex: 'nomor_polisi', key: 'nomor_polisi', width: 130,
				render: (v) => v || <Text type="secondary">—</Text> },
			{ title: 'UPT', dataIndex: 'upt_nama', key: 'upt_nama', render: (v) => v && v !== '-' ? v : <Text type="secondary">—</Text> },
			{ title: 'Kategori', dataIndex: 'kategori_label', key: 'kategori_label' },
			{ title: 'Sumber', dataIndex: 'sumber', key: 'sumber', width: 110,
				render: (v) => v ? <Tag>{v}</Tag> : <Text type="secondary">—</Text> },
			{ title: 'Dicatat Oleh', key: 'oleh', width: 140,
				render: (_, row) => row.diajukan_oleh_nama || row.disetujui_oleh_nama || <Text type="secondary">—</Text> },
			{ title: 'Bentrok', key: 'bentrok', width: 220, align: 'center',
				render: (_, row) => {
					if (!row.bentrok_transaksi_aktif) return <Text type="secondary">—</Text>;
					const detail = (row.transaksi_bentrok || []).map((t, i) => (
						<div key={i}>
							{t.nomor_polisi} - {t.upt_nama} ({t.paid_on})
						</div>
					));
					return (
						<Tooltip title={<div>{detail}{row.bentrok_beda_upt && <div style={{ marginTop: 4 }}>⚠️ beda UPT dari catatan rusak ini</div>}</div>}>
							<Tag icon={<WarningOutlined />} color="error" style={{ cursor: 'help' }}>
								Bentrok: {(row.transaksi_bentrok || []).map((t) => t.nomor_polisi).join(', ')}
							</Tag>
						</Tooltip>
					);
				} },
			{ title: 'Status', key: 'status_cabut', width: 170, align: 'center',
				render: (_, row) => row.dicabut_at ? (
					<Tooltip title={<div>
						<div>Oleh: {row.dicabut_oleh_nama || '-'}</div>
						<div>Pada: {row.dicabut_at}</div>
						<div>Alasan: {row.alasan_pencabutan}</div>
					</div>}>
						<Tag icon={<CheckCircleOutlined />} color="default">Sudah Dicabut</Tag>
					</Tooltip>
				) : (
					<Tag color="red">Aktif (memblokir nomor)</Tag>
				) },
			{ title: 'Aksi', key: 'aksi', width: 110, fixed: 'right', align: 'center',
				render: (_, row) => (
					<Button danger size="small" icon={<UndoOutlined />} disabled={Boolean(row.dicabut_at)}
						onClick={() => this.openCabut(row)}>
						Cabut
					</Button>
				) },
		];
	}

	renderModalCabut() {
		const { modalCabut, cabutTarget, alasan, loadingCabut, isMobile } = this.state;
		if (!cabutTarget) return null;
		return (
			<Modal
				title={<span><ExclamationCircleOutlined style={{ color: '#cf1322', marginRight: 8 }} />Cabut Catatan Notice Rusak</span>}
				visible={modalCabut}
				onCancel={() => this.setState({ modalCabut: false, cabutTarget: null, alasan: '' })}
				onOk={this.handleCabut}
				okText="Cabut"
				okButtonProps={{ danger: true, loading: loadingCabut }}
				width={isMobile ? '95%' : 520}
			>
				<div style={{ marginBottom: 12, fontSize: 13 }}>
					<div><Text strong>Notice:</Text> {cabutTarget.kode_notice} {cabutTarget.nomor_notice}</div>
					<div><Text strong>UPT:</Text> {cabutTarget.upt_nama || '-'}</div>
					<div><Text strong>Kategori:</Text> {cabutTarget.kategori_label}</div>
					<div><Text strong>Dicatat:</Text> {cabutTarget.created_at}</div>
				</div>
				<Alert
					type="warning"
					showIcon
					style={{ marginBottom: 12, borderRadius: 8 }}
					message="Nomor ini akan bisa dipakai lagi"
					description="Setelah dicabut, nomor ini tidak lagi dianggap rusak - bisa diterbitkan ulang lewat pembayaran normal & dipakai di Koreksi Nomor Notice. Catatan ini TETAP tersimpan untuk audit (tidak dihapus). Kalau nomor yang BENAR-BENAR rusak ternyata nomor lain, catat ulang lewat Transaksi → Batal Notice → Input Manual."
				/>
				{!cabutTarget.bentrok_transaksi_aktif && (
					<Alert
						type="info"
						showIcon
						style={{ marginBottom: 12, borderRadius: 8 }}
						message="Nomor ini sedang TIDAK dipegang transaksi aktif mana pun - pastikan dulu blanko fisiknya memang tidak rusak sebelum mencabut."
					/>
				)}
				<Form.Item label="Alasan Pencabutan (wajib, min. 10 karakter)" style={{ marginBottom: 0 }}>
					<TextArea
						rows={3}
						maxLength={500}
						showCount
						value={alasan}
						placeholder="contoh: Salah lapor, fisik notice ini baik-baik saja dan sedang dipakai transaksi aktif"
						onChange={(e) => this.setState({ alasan: e.target.value })}
					/>
				</Form.Item>
			</Modal>
		);
	}

	render() {
		const {
			isMobile, loading, listData, pagination, ringkasan,
			filterKodeNotice, filterNomorNotice, filterNomorPolisi,
			filterUptId, filterKabupatenId, filterStatusCabut, filterBentrokSaja, filterTanggal,
			listUpt, loadingUpt, listKabupaten, loadingKabupaten,
		} = this.state;

		return (
			<div>
				<Helmet>
					<title>{configClass.title + ' | ' + config.get_site_info().name}</title>
					<style>{`
						.audit-notice-rusak-wrap .ant-table-thead > tr > th {
							background: linear-gradient(135deg, #0f284711, #1e4d8a11) !important;
							font-weight: 700; font-size: 13px; color: #0f2847;
							border-bottom: 2px solid #d0dff5;
						}
						.audit-notice-rusak-wrap .ant-table-tbody > tr:hover > td { background: #e8f0fb !important; }
						.audit-notice-rusak-wrap .ant-table-tbody > tr:nth-child(even) > td { background: #fafafa; }
						.audit-notice-rusak-wrap .ant-table-tbody > tr:nth-child(even):hover > td { background: #e8f0fb !important; }
						.audit-notice-rusak-wrap .ant-table-tbody > tr.row-bentrok > td { background: #fff1f0 !important; }
						.audit-notice-rusak-wrap .ant-table-tbody > tr.row-bentrok:hover > td { background: #ffe0dd !important; }
					`}</style>
				</Helmet>

				<Card className="audit-notice-rusak-wrap" style={{ borderRadius: 14, boxShadow: '0 4px 20px rgba(0,0,0,0.07)', overflow: 'hidden' }} bodyStyle={{ padding: 0 }}>
					<div style={{
						padding: '16px 20px',
						background: 'linear-gradient(135deg, #0f2847, #1a3a6b)',
						display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 10,
					}}>
						<div>
							<div style={{ color: '#fff', fontWeight: 700, fontSize: 17 }}>
								<WarningOutlined style={{ marginRight: 8 }} />
								{configClass.title}
							</div>
							<div style={{ fontSize: 11, color: '#94a3b8', marginTop: 2 }}>
								Tinjau & cabut catatan notice rusak yang salah lapor
							</div>
						</div>
						<Tooltip title="Refresh data">
							<Button icon={<RedoOutlined />} style={{ borderRadius: 8, background: 'rgba(255,255,255,0.15)', border: 'none', color: '#fff' }}
								onClick={() => this.fetchData(pagination.current)}>
								{!isMobile && 'Refresh'}
							</Button>
						</Tooltip>
					</div>

					<div style={{ padding: '16px 20px 0', display: 'flex', flexWrap: 'wrap', gap: 12 }}>
						<div style={{ background: '#fff', borderRadius: 14, padding: '14px 18px', border: '1px solid #1d4ed822', boxShadow: '0 2px 12px #1d4ed814', flex: '1 1 180px' }}>
							<div style={{ fontSize: 10, color: '#64748b', fontWeight: 700, textTransform: 'uppercase', letterSpacing: .8, marginBottom: 6 }}>Notice Rusak Aktif</div>
							<div style={{ fontSize: 20, fontWeight: 900, color: '#1d4ed8', fontFamily: 'monospace' }}>{ringkasan.total_belum_dicabut}</div>
						</div>
						<div style={{ background: '#fff', borderRadius: 14, padding: '14px 18px', border: '1px solid #cf132222', boxShadow: '0 2px 12px #cf132214', flex: '1 1 180px' }}>
							<div style={{ fontSize: 10, color: '#64748b', fontWeight: 700, textTransform: 'uppercase', letterSpacing: .8, marginBottom: 6 }}>Bentrok Transaksi Aktif</div>
							<div style={{ fontSize: 20, fontWeight: 900, color: '#cf1322', fontFamily: 'monospace' }}>{ringkasan.total_bentrok}</div>
						</div>
						<div style={{ background: '#fff', borderRadius: 14, padding: '14px 18px', border: '1px solid #38861222', boxShadow: '0 2px 12px #38861214', flex: '1 1 180px' }}>
							<div style={{ fontSize: 10, color: '#64748b', fontWeight: 700, textTransform: 'uppercase', letterSpacing: .8, marginBottom: 6 }}>Sudah Dicabut</div>
							<div style={{ fontSize: 20, fontWeight: 900, color: '#389e0d', fontFamily: 'monospace' }}>{ringkasan.total_sudah_dicabut}</div>
						</div>
					</div>

					<div style={{ padding: 16 }}>
						<Form layout="vertical" onFinish={this.handleFilter}>
							<Row gutter={12}>
								<Col xs={12} sm={6} md={4}>
									<Form.Item label="Kabupaten" style={{ marginBottom: 10 }}>
										<Select allowClear showSearch placeholder="Semua kabupaten" loading={loadingKabupaten}
											disabled={this.isKabupatenLocked()}
											filterOption={false} onSearch={(v) => this.fetchKabupatenList(v)}
											value={filterKabupatenId}
											onChange={(v) => this.setState({ filterKabupatenId: v, filterUptId: undefined }, () => this.fetchUptList('', v))}>
											{listKabupaten.map((kab) => (
												<Option key={kab.id} value={kab.id}>{kab.name}</Option>
											))}
										</Select>
									</Form.Item>
								</Col>
								<Col xs={12} sm={6} md={4}>
									<Form.Item label="UPT" style={{ marginBottom: 10 }}>
										<Select allowClear showSearch placeholder="Semua UPT" loading={loadingUpt}
											filterOption={false} onSearch={(v) => this.fetchUptList(v)}
											value={filterUptId} onChange={(v) => this.setState({ filterUptId: v })}>
											{listUpt.map((upt) => (
												<Option key={upt.id} value={upt.id}>{upt.nama}</Option>
											))}
										</Select>
									</Form.Item>
								</Col>
								<Col xs={12} sm={6} md={4}>
									<Form.Item label="Status Pencabutan" style={{ marginBottom: 10 }}>
										<Select value={filterStatusCabut} onChange={(v) => this.setState({ filterStatusCabut: v })}>
											<Option value="belum">Belum Dicabut</Option>
											<Option value="sudah">Sudah Dicabut</Option>
											<Option value="semua">Semua</Option>
										</Select>
									</Form.Item>
								</Col>
								<Col xs={12} sm={6} md={4} style={{ display: 'flex', alignItems: 'flex-end', paddingBottom: 10 }}>
									<Checkbox checked={filterBentrokSaja} onChange={(e) => this.setState({ filterBentrokSaja: e.target.checked })}>
										Hanya yang bentrok
									</Checkbox>
								</Col>
							</Row>
							<Row gutter={12}>
								<Col xs={12} sm={6} md={4}>
									<Form.Item label="Kode Notice" style={{ marginBottom: 10 }}>
										<Input placeholder="contoh: A" value={filterKodeNotice}
											onChange={(e) => this.setState({ filterKodeNotice: e.target.value })} />
									</Form.Item>
								</Col>
								<Col xs={12} sm={6} md={4}>
									<Form.Item label="Nomor Notice" style={{ marginBottom: 10 }}>
										<Input placeholder="nomor seri" value={filterNomorNotice}
											onChange={(e) => this.setState({ filterNomorNotice: e.target.value })} />
									</Form.Item>
								</Col>
								<Col xs={12} sm={6} md={4}>
									<Form.Item label="Nomor Polisi" style={{ marginBottom: 10 }}>
										<Input placeholder="contoh: KH1234AB" value={filterNomorPolisi}
											onChange={(e) => this.setState({ filterNomorPolisi: e.target.value })} />
									</Form.Item>
								</Col>
								<Col xs={24} sm={12} md={6}>
									<Form.Item label="Rentang Tanggal Dicatat" style={{ marginBottom: 10 }}>
										<RangePicker style={{ width: '100%' }} value={filterTanggal}
											onChange={(v) => this.setState({ filterTanggal: v || [] })} />
									</Form.Item>
								</Col>
							</Row>
							<div style={{ textAlign: 'right' }}>
								<Button onClick={this.handleReset} style={{ marginRight: 8 }}>Reset</Button>
								<Button type="primary" icon={<SearchOutlined />} htmlType="submit"
									style={{ background: '#1e4d8a', borderColor: '#1e4d8a' }}>
									Cari
								</Button>
							</div>
						</Form>
					</div>

					<Table
						columns={this._columns()}
						dataSource={listData}
						loading={loading}
						rowKey="id"
						scroll={{ x: 1400 }}
						size="middle"
						rowClassName={(row) => row.bentrok_transaksi_aktif && !row.dicabut_at ? 'row-bentrok' : ''}
						locale={{ emptyText: <Empty description="Tidak ada catatan notice rusak" /> }}
						pagination={{
							current: pagination.current, pageSize: pagination.pageSize, total: pagination.total,
							showSizeChanger: true, pageSizeOptions: ['25', '50', '100'],
							showTotal: (total, range) => `${range[0]}-${range[1]} dari ${total} data`,
							onChange: (page, pageSize) => this.setState(prev => ({ pagination: { ...prev.pagination, pageSize } }), () => this.fetchData(page)),
						}}
					/>
				</Card>

				{this.renderModalCabut()}

				<ErrorAlertModal
					visible={this.state.errMsg !== ''}
					title={this.state.errTitle}
					error={this.state.errMsg}
					onClose={() => this.setState({ errMsg: '', errTitle: '' })}
				/>
			</div>
		);
	}
}

const mapStateToProps = state => state.configReducers;
export default connect(mapStateToProps, { initHandler, ajaxViewHandler, ajaxHandler, setConfig })(AuditNoticeRusak);
